/** Optional Arabic overrides when API fields are missing (see orderLocalization). */

function normalizeEnglishKey(s: string): string {
  return s.trim().replace(/\s+/g, ' ')
}

export const ORDER_STEP4_SERVICE_DESCRIPTION_AR_BY_TEMPLATE_ID: Record<string, string> = {}
export const ORDER_STEP4_SERVICE_DESCRIPTION_AR_BY_ENGLISH: Record<string, string> = {}
export const ORDER_STEP4_APPOINTMENT_LABEL_AR_BY_SPEC_ID: Record<string, string> = {}
export const ORDER_STEP4_APPOINTMENT_LABEL_AR_BY_ENGLISH: Record<string, string> = {}
export const ORDER_STEP4_SERVICE_NAME_AR_BY_TEMPLATE_ID: Record<string, string> = {}
export const ORDER_STEP4_SERVICE_NAME_AR_BY_ENGLISH: Record<string, string> = {}
export const ORDER_STEP4_ORDER_TEMPLATE_NAME_AR_BY_ID: Record<string, string> = {}
export const ORDER_STEP4_ORDER_TEMPLATE_NAME_AR_BY_ENGLISH: Record<string, string> = {}
export const ORDER_STEP4_ORDER_TEMPLATE_DESCRIPTION_AR_BY_ID: Record<string, string> = {}
export const ORDER_STEP4_ORDER_TEMPLATE_DESCRIPTION_AR_BY_ENGLISH: Record<string, string> = {}

export function getServiceTemplateDescriptionArOverride(
  templateId: string,
  englishSource: string | undefined
): string | undefined {
  const byId = ORDER_STEP4_SERVICE_DESCRIPTION_AR_BY_TEMPLATE_ID[templateId]
  if (byId) return byId
  const key = normalizeEnglishKey(englishSource ?? '')
  if (!key) return undefined
  return ORDER_STEP4_SERVICE_DESCRIPTION_AR_BY_ENGLISH[key]
}

export function getAppointmentSpecLabelArOverride(
  specId: string,
  englishLabel: string
): string | undefined {
  const byId = ORDER_STEP4_APPOINTMENT_LABEL_AR_BY_SPEC_ID[specId]
  if (byId) return byId
  const key = normalizeEnglishKey(englishLabel)
  if (!key) return undefined
  return ORDER_STEP4_APPOINTMENT_LABEL_AR_BY_ENGLISH[key]
}

export function getServiceTemplateNameArOverride(
  templateId: string,
  englishName: string | undefined
): string | undefined {
  const byId = ORDER_STEP4_SERVICE_NAME_AR_BY_TEMPLATE_ID[templateId]
  if (byId) return byId
  const key = normalizeEnglishKey(englishName ?? '')
  if (!key) return undefined
  return ORDER_STEP4_SERVICE_NAME_AR_BY_ENGLISH[key]
}

export function getOrderTemplateNameArOverride(
  templateId: string,
  englishName: string | undefined
): string | undefined {
  const byId = ORDER_STEP4_ORDER_TEMPLATE_NAME_AR_BY_ID[templateId]
  if (byId) return byId
  const key = normalizeEnglishKey(englishName ?? '')
  if (!key) return undefined
  return ORDER_STEP4_ORDER_TEMPLATE_NAME_AR_BY_ENGLISH[key]
}

export function getOrderTemplateDescriptionArOverride(
  templateId: string,
  englishSource: string | undefined
): string | undefined {
  const byId = ORDER_STEP4_ORDER_TEMPLATE_DESCRIPTION_AR_BY_ID[templateId]
  if (byId) return byId
  const key = normalizeEnglishKey(englishSource ?? '')
  if (!key) return undefined
  return ORDER_STEP4_ORDER_TEMPLATE_DESCRIPTION_AR_BY_ENGLISH[key]
}
